import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import UrlHandlerApiService from "./url-handler.service";

const CanceledSubscriptionsApiService = {
  URL: "",
  async init() {
    Vue.use(VueAxios, axios);
    this.URL = await UrlHandlerApiService.getBaseUrl();
  },

  getAllCanceledSubscriptions(params = {}) {
    return Vue.axios
      .get(`${this.URL}/api/user/subscription/admin/cancellation-reasons/list`, {
        params: params,
        paramsSerializer: this.paramsSerializer
      })
      .catch(error => {
        throw new Error(`[KT] CanceledSubscriptionsApiService ${error}`);
      });
  },

  getAllSubscriptionPlans() {
    return Vue.axios.get(`${this.URL}/api/user/subscription/admin/all-plans`).catch(error => {
      throw new Error(`[KT] CanceledSubscriptionsApiService ${error}`);
    });
  },

  getCanceledSubscriptionsReport(params = {}) {
    return Vue.axios
      .get(`${this.URL}/api/user/subscription/admin/cancellation-reasons/report`, {
        params: params,
        paramsSerializer: this.paramsSerializer,
        responseType: "blob"
      })
      .catch(error => {
        throw new Error(`[KT] CanceledSubscriptionsApiService ${error}`);
      });
  },

  paramsSerializer: function(params) {
    const searchParams = new URLSearchParams();
    for (const key in params) {
      const value = params[key];
      if (Array.isArray(value)) {
        value.forEach(item => searchParams.append(key, item));
      } else if (value !== null && value !== undefined && value !== "") {
        searchParams.append(key, value);
      }
    }
    return searchParams.toString();
  }
};

export default CanceledSubscriptionsApiService;
